import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import styles from "./styles.module.css";

const FloatingEditButton = ({ isEditing = false, onEdit, onSave, onCancel, position = { bottom: "30px", right: "30px" } }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	useEffect(() => {
		if (!isEditing) {
			setIsExpanded(false);
		}
	}, [isEditing]);

	const handleMainButtonClick = () => {
		if (isEditing) {
			setIsExpanded(!isExpanded);
		} else {
			onEdit();
		}
	};

	const handleSave = () => {
		onSave();
		setIsExpanded(false);
	};

	const handleCancel = () => {
		onCancel();
		setIsExpanded(false);
	};

	return (
		<div className={styles.floatingButtonContainer} style={position}>
			<div className={styles.classFloating}>
				<Button
					icon
					className={`${styles.floatingButton} ${isExpanded ? styles.floatingButtonExpanded : ""}`}
					onClick={handleMainButtonClick}>
					<i className={`icon ${isEditing ? "save" : "edit"}`} />
				</Button>
			</div>

			{isEditing && (
				<div className={`${styles.actionButtonsContainer} ${isExpanded ? styles.actionButtonsContainerVisible : ""}`}>
					<Button className={`${styles.actionButton} ${styles.saveButton}`} onClick={handleSave}>
						<i className="icon save" /> Guardar
					</Button>
					<Button className={`${styles.actionButton} ${styles.cancelButton}`} onClick={handleCancel}>
						<i className="icon cancel" /> Cancelar
					</Button>
				</div>
			)}
		</div>
	);
};
FloatingEditButton.propTypes = {
	isEditing: PropTypes.bool,
	onEdit: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,

	position: PropTypes.shape({
		bottom: PropTypes.string,
		right: PropTypes.string,
	}),
};

export default FloatingEditButton;
